/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/
import { VisionApplication } from '../application';
import { PublishTopic } from '../events';
import { BaseService } from './base';

interface UserSettingsDTO {
    settings: string;
    userId: string;
}

export interface UserSettings {
    tabs: string[];
    asset_tail: boolean;
    icons: boolean;
    cluster: boolean;
    defaulltZoom: number;
}

export interface UserDTO {
    id: string;
    username: string;
    password: string;
    settings: string;
    editor: boolean;
    timezone: string;
    assignedRoles: string[];
}

export class UserService extends BaseService {
    icons: boolean;
    userSettings!: UserSettingsDTO;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    settings!: any; // JSON parsed version of the settings.

    app: VisionApplication;
    selectedFolder: string | null;
    treeSortDirection: string | null;
    selectedWorkspace: string | null; // The users selected workspaced ( stored in localstorage )

    constructor(app: VisionApplication) {
        super();
        this.app = app;
        this.selectedFolder = null;
        this.treeSortDirection = null;
        this.selectedWorkspace = null;
        this.icons = false;
    }

    async getSettings() {
        const response = await this.get<UserSettingsDTO>(this.url + '/api/' + this.orgid + '/user/settings');
        return response;
    }

    async createUser(user: UserDTO) {
        const response = await this.post<UserDTO>(this.url + '/api/' + this.orgid + '/user', user);
        return response;
    }

    /** Delete a user from the system.
     *  @param user The user to delete.  Only the ID is really required here.
     */
    async deleteUser(user: UserDTO) {
        const response = await this.delete<UserDTO>(this.url + '/api/' + this.orgid + '/user', user);
        return response;
    }

    async updateUser(user: UserDTO) {
        const response = await this.put<UserDTO>(this.url + '/api/' + this.orgid + '/user', user);
        return response;
    }

    /** Get a list of all the users.
     *
     * @returns
     */
    async getUsers() {
        const response = await this.get<UserDTO[]>(this.url + '/api/' + this.orgid + '/users');
        return response;
    }

    public async init() {
        return new Promise((resolve, _reject) => {
            this.selectedFolder = localStorage.getItem('selected_folder');
            this.treeSortDirection = localStorage.getItem('tree_sort_direction');
            this.selectedWorkspace = localStorage.getItem('selected_workspace');

            const request = this.getSettings();
            request.then((data) => {
                if (data.parsedBody) {
                    this.userSettings = data.parsedBody;
                    this.settings = JSON.parse(data.parsedBody.settings);
                    if (this.settings?.icons == true) {
                        this.icons = true;
                    } else {
                        this.icons = false;
                    }

                    this.app.pubsub.publish(PublishTopic.USER_SETTINGS_LOADED, this.userSettings);
                }
                console.log('User Service Loaded');
                resolve('Loaded');
            });
        });
    }
}
